export default {
    CommunicationConstants: {
        AllowedOrigins: process.env.allowed_origins,
        AllowMultipleWhitelist: [ /* list of message.types to allow multiples in cache, should be all lower-case strings */],
        Source: {
            Client: "client",
            NextIT: "nit",
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/client-communicator.ts